interface Props {
  testid?: string;
  amount: number;
  className?: string;
}

function formatDisplayAmount(amount: number): number {
  if (amount < 0) {
    return amount * -1;
  }

  return amount;
}

export function Price(props: Props) {
  const { testid, amount, className } = props;
  const displayAmount = formatDisplayAmount(amount);
  const sign = amount < 0 ? '-' : '';

  return (
    <span className={className} data-testid={`${testid}-price`}>
      {sign}${displayAmount.toFixed(2)}
    </span>
  );
}
